export default __webpack_public_path__ + "static/media/Group 5183.c4302416.svg";